import * as React from 'react';
import cn from 'classnames';
import { useTheme } from '../../theme';
import { default as BaseButton } from '../../BaseComponents/Button';
import { CdnIcon } from '@shared/ui';
const statusIconKeyMap = {
    done: 'Info/Item Icluded',
    error: 'Info/Not included'
};
const renderNode = (node, className) => typeof node === 'string' ? (React.createElement("div", { className: className, dangerouslySetInnerHTML: { __html: node } })) : (React.createElement("div", { className: className }, node));
const Notification = ({ className, iconClassName, contentClassName, titleClassName, textClassName, contextClassName, globalClassName, htmlClassName, title, text, image, icon, type, actionClassName, actionText, status, actionVariant = 'optionAction', actionLoading, onClickAction, code, renderMessagesWithoutWrapper, asHtml, hideIcon, style }) => {
    var _a;
    const { Notification: css } = useTheme('BaseComponents');
    const isContextType = type === 'context';
    if (renderMessagesWithoutWrapper && typeof text === 'string') {
        return React.createElement("div", { className: htmlClassName, style: style, dangerouslySetInnerHTML: { __html: text } });
    }
    return (React.createElement("div", { className: cn(css.wrapper, className, {
            [css.context]: !asHtml && isContextType,
            [css.global]: !asHtml && !isContextType,
            [css.success]: status === 'done' && !asHtml,
            [css.subscription]: status === 'subscription',
            [css.warning]: status === 'warning',
            [css.error]: status === 'error',
            [contextClassName]: isContextType && contextClassName,
            [globalClassName]: !isContextType && globalClassName
        }), "data-code": code, style: style },
        !hideIcon &&
            (image ? (React.createElement("img", { className: css.image, src: image, alt: "" })) : (React.createElement("div", { className: cn(css.icon, iconClassName) }, icon ? icon : React.createElement(CdnIcon, { icon: (_a = statusIconKeyMap[status]) !== null && _a !== void 0 ? _a : 'Info/Details' })))),
        React.createElement("div", { className: css.content__wrapper },
            React.createElement("div", { className: css.wrapper__inner }, asHtml && typeof text === 'string' ? (React.createElement("div", { className: htmlClassName, dangerouslySetInnerHTML: { __html: text } })) : (React.createElement("div", { className: cn(css.content, contentClassName) },
                title && renderNode(title, cn(css.title, titleClassName)),
                text && renderNode(text, cn(css.text, textClassName))))),
            actionText && !asHtml && (React.createElement(BaseButton, { variant: actionVariant, className: cn(css.action, actionClassName), onClick: onClickAction, isLoading: actionLoading }, actionText)))));
};
export default Notification;
